module.exports = __webpack_public_path__ + "static/img/img_pfgm.2bf76294.png";